import { useState } from "react";
import { Plus, Minus } from "lucide-react";

const FAQS = [
  {
    q: "What exactly is RAPID NeuroFascial Reset?",
    a: "RAPID NFR is a science-based, neurologically focused manual therapy. You actively move through prescribed patterns while I work with the targeted tissue. It's fast, effective, and addresses the source of pain — not just the symptom.",
  },
  {
    q: "Does RAPID NFR hurt?",
    a: "It can be uncomfortable because we deliberately target the root of the pain — but I always work within your tolerance and communicate with you throughout the session.",
  },
  {
    q: "Do I need to undress for a session?",
    a: "No. RAPID is a fully clothed therapy. Wear comfortable, loose-fitting athletic wear so you can move freely.",
  },
  {
    q: "Do you offer direct billing?",
    a: "Yes. I offer direct billing to most major Canadian insurance providers, including Alberta Blue Cross, Sun Life, Manulife, Canada Life and more. Coverage depends on your specific plan.",
  },
  {
    q: "How many sessions will I need?",
    a: "Many clients feel meaningful relief after just one or two sessions. More chronic or complex cases may take longer. We'll discuss a realistic plan at your first appointment.",
  },
  {
    q: "Where are you located?",
    a: "KneadRelief is located at 2 Bowbank Crescent NW, Calgary AB — in the Bowness area of NW Calgary. Easy access from surrounding communities.",
  },
];

export default function FAQ() {
  const [open, setOpen] = useState(0);

  return (
    <section
      id="faq"
      data-testid="faq-section"
      className="relative py-20 sm:py-28 lg:py-32 bg-slate-50/70"
    >
      <div className="max-w-4xl mx-auto px-6 sm:px-8">
        <div className="text-center mb-12">
          <div className="text-xs uppercase tracking-[0.2em] font-semibold text-blue-800 mb-4">
            Common Questions
          </div>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-slate-900 leading-[1.1]">
            Frequently asked questions.
          </h2>
        </div>

        <div className="bg-white rounded-3xl border border-slate-100 shadow-sm divide-y divide-slate-100 overflow-hidden">
          {FAQS.map((item, i) => {
            const isOpen = open === i;
            return (
              <div key={item.q} data-testid={`faq-item-${i}`}>
                <button
                  onClick={() => setOpen(isOpen ? -1 : i)}
                  data-testid={`faq-toggle-${i}`}
                  className="w-full flex items-center justify-between gap-6 text-left p-6 sm:p-7 hover:bg-blue-50/40 transition-colors"
                  aria-expanded={isOpen}
                >
                  <span className="font-display font-semibold text-lg text-slate-900 tracking-tight">
                    {item.q}
                  </span>
                  <span
                    className={`shrink-0 w-9 h-9 rounded-full flex items-center justify-center transition-all ${
                      isOpen ? "bg-blue-800 text-white rotate-180" : "bg-blue-50 text-blue-800"
                    }`}
                  >
                    {isOpen ? <Minus size={16} strokeWidth={2.4} /> : <Plus size={16} strokeWidth={2.4} />}
                  </span>
                </button>
                <div
                  className={`grid transition-all duration-300 ease-out ${
                    isOpen ? "grid-rows-[1fr] opacity-100" : "grid-rows-[0fr] opacity-0"
                  }`}
                >
                  <div className="overflow-hidden">
                    <div className="px-6 sm:px-7 pb-6 sm:pb-7 -mt-1 text-slate-600 leading-relaxed">
                      {item.a}
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
